<template lang="pug">
.page-layout
  .page-header
    .title {{ title }}
  .page-content
    .operation
      .search
        slot(name="search")
      .action
        slot(name="action")
    .tab
      slot(name="tab")
    .list-container
      slot(name="list")
    .pager-container(v-if="pager")
      slot(name="pager")
        el-pagination(background layout="prev, pager, next"
          :page-size="pager.pageSize" :total="pager.total"
          :current-page="pager.page"
          @current-change="handlePagerChange")
    slot
  .page-extend
    slot(name="extend")
</template>

<script>
export default {
  name: "ManagerPage",
  props: {
    title: String,
    pager: {
      type: [Object, Boolean],
      default: false,
    }
  },
  methods: {
    handlePagerChange(current) {
      this.$emit('pageChange', current);
    }
  }
}
</script>

<style lang="scss" scoped>
.page-layout{
  padding: 16px 24px;
  .page-header{
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    .title{
      font-weight: 700;
      font-size: 16px;
      color: #202948;
      padding: 10px 0;
    }
  }
  .page-content{
    .operation{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px 0;
    }
    .pager-container{
      padding-top: 16px;
      text-align: right;
    }
  }
}
</style>
